import React from 'react';
import { motion } from 'framer-motion';
import './AboutSection.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faBriefcase, faBullseye } from '@fortawesome/free-solid-svg-icons';

const AboutSection = () => {

  // Animation Framer Motion
  const containerVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { staggerChildren: 0.15, when: "beforeChildren" } }
  };
  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
    hover: { y: -8, boxShadow: "0 8px 32px 0 rgba(161, 120, 180, 0.15)" }
  };


  return (
    <section id="about" className="about-container">
      <motion.div
        className="about-section"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <motion.div className="about-content" variants={itemVariants}>
          <h1 className="about-title">À propos de moi</h1>
          <p className="about-text">
            Développeuse web orientée <span className="highlight">problem-solving</span> et autodidacte depuis plus d'un an,{' '}
            je cherche à renforcer mes compétences en développement <span className="highlight">full-stack</span>.{' '}
            <span className="highlight">Curieuse insatiable</span>, j'explore continuellement de nouveaux horizons pour enrichir mes compétences !
          </p>
        </motion.div>
        <div className="about-image-container">
          <img src={process.env.PUBLIC_URL + '/AboutSection/moi.JPG'} alt="Moi" className="about-image" />
        </div>
      </motion.div>
      <motion.div
        className="section-container"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <div className="cards-grid">
          <motion.div className="feature-card" variants={cardVariants} whileHover="hover">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faUser} />
            </div>
            <h2 className="feature-title">Qui suis-je ?</h2>
            <p className="feature-text">
              Tatiana, 25 ans, développeuse full-stack en devenir. J'ai débuté en autodidacte avant de me former professionnellement.
            </p>
          </motion.div>
          <motion.div className="feature-card" variants={cardVariants} whileHover="hover">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faBriefcase} />
            </div>
            <h2 className="feature-title">Mon parcours</h2>
            <p className="feature-text">
              Je me suis formée avec OpenClassrooms - <span className="highlight">Développeuse Web spécialité Intégratrice Web</span>
            </p>
          </motion.div>
          <motion.div className="feature-card" variants={cardVariants} whileHover="hover">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faBullseye} />
            </div>
            <h2 className="feature-title">Mon objectif</h2>
            <p className="feature-text">
              Découvrir plus en profondeur le monde du back-end, pour améliorer mes performances générales et viser le <span className="highlight">full-stack</span>,{' '}
              en alliant rigueur et créativité.
            </p>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default AboutSection;
